// extracted by mini-css-extract-plugin
export var cardLayout = "_9o-1";
export var paginationContainer = "_9o-0";